/**
 *
 * @param {String} selector
 * @param {Object} options
 * @returns
 */

let cookieDefaults = {
  path: '/',
  secure: false,
}

class SDC_Cookie {
  constructor(name, value, options = {}) {
    this.name = name;
    this.value = value;
    this.options = this.mergeOptions(cookieDefaults, options)
  }

  init() {
    this.getCookie(this.name);
  }

  /**
   *
   * @param {Object} defaults
   * @param {Object} settings
   * @returns Object
   */
  mergeOptions(defaults, settings) {
    let options = Object.assign({}, defaults, settings)
    return options;
  }

  /**
   * Get Cookie by Name
   * @param {*} name
   * @returns
   */
  getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }

  /**
   * Set Cookie by Name
   * @param {*} name
   * @returns
   */
  setCookie() {
    document.cookie = this.cookieOptions();
  }

  /**
   * Update Cookie by Name
   * @param {*} name
   * @returns
   */
  get updateCookie() {
    return encodeURIComponent(this.name) + '=' + encodeURIComponent(this.value);
  }

  /**
   * Check Cookie by Name
   * @param {*} name
   * @returns
   */
  checkCookie(name) {
    if (!this.getCookie(name)) return;

  }

  /**
   * Cookie Expires
   */
  cookieExpires() {
    if (this.options.expires instanceof Date) {
      this.options.expires = this.options.expires.toUTCString();
    }
  }

  cookieOptions() {
    let cookie = this.updateCookie
    for (let key in this.options) {
      let value = this.options[key];

      cookie += "; " + key;
      if (true !== value) {
        cookie += "=" + value;
      }
    }

    return cookie;
  }


}

// setCookie('user', 'John', {secure: true, 'max-age': 3600});